/* eslint ember/no-classic-classes:"off" */
import RESTAdapter from '@ember-data/adapter/rest';
import { captureException } from '@sentry/browser';
import { resolve } from 'rsvp';
export default RESTAdapter.extend({
  init(args) {
    this._super(args);
    this.useFetch = false;
  },
  namespace: '/api/v1',
  pathForType() {
    return 'processing-fees';
  },
  // Overriding the ajax call in RESTAdapter to protect other functionality on this page
  ajax(url, type, options) {
    const superResponse = this._super(url, type, options);
    return superResponse.then(resp => resolve(resp)).catch(() => {
      // Return a dummy payload so the page does not break
      const blank_payload = {
        processing_fees: {},
        processing_fees_collection: []
      };
      // Silence all errors, this data is required, but unmaintained
      return resolve(blank_payload);
    });
  },
  // Capturing the actual error in `handleResponse()` is easier than in `ajax()`
  // Ignore 401 or 403 errors, we suspect they are due to session expiry
  // Ignoring these errors is safe, this is a low importance endpoint
  handleResponse(status, headers, payload, requestData) {
    if (status >= 400 && status !== 401 && status !== 403) {
      const err = new Error('Error loading Processing fees');
      captureException(err, {
        extra: {
          status,
          payload,
          requestData
        }
      });
    }
    return this._super(status, headers, payload, requestData);
  }
});